<template>
  <div class="container-full">
    <Notifications/>
    <Navbar :urlDev="urlDev"/>

    <div v-if="loading" class="spinner-container">
      <div class="spinner-border spinner-light"></div>
    </div>
    <div v-else-if="urlDev === '.dev.opoint.com'" v-for="hint in hints" :key="`hint-${hint.id}`"
         class="impact-container">
      <!-- TODO: ^ remove above else-if check -->
      <h2>Hint: {{ hint.url_rule }}</h2>
      <table class="hint-impact-table">
        <thead>
        <tr>
          <th></th>
          <!-- TODO: in Tippy, force text to be on one line without breaking-->
          <th
            v-for="hash in hint.hashes"
            :key="`hash-${hint.id}-${hash}`"
            :content="hashes[hash] || '(not found)'"
            v-tippy>
            {{ (hash in hashes) ? getUntil(hashes[hash], '(') : '(no name)' }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(article, linkId) in hint.articles" :key="`article-${hint.id}-${linkId}`">
          <td class="article-name">
                        <span
                          :content="(linkId in allArticles) ? allArticles[linkId].header : '(no name)'"
                          v-tippy>
                            {{ (linkId in allArticles) ? ellipsize(allArticles[linkId].header, 20) : '(no name)' }}
                        </span>
          </td>
          <td
            v-for="(impact, hash) in article"
            :key="`impact-${hint.id}-${linkId}-${hash}}`"
            :style="getStyle(impact)">
            <span v-if="impact.real !== 0 || impact.potential !== 0">
              {{ impact.real }} / {{ impact.potential }}
            </span>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import Navbar from '../components/Navbar'
  import Notifications from '../components/Notifications'

  import { Events } from '../events'

  import { RepositoryFactory } from '../data/RepositoryFactory'

  const OHMRepository = RepositoryFactory.get('ohm')

  import Values from 'values.js'

  import ellipsize from '../mixins/ellipsize'
  import getUntil from '../mixins/get-until'

  export default {
    name: 'Impact',
    components: { Navbar, Notifications },
    mixins: [ellipsize, getUntil],
    data: () => ({
      idSite: null,
      idLink: null,
      loading: true,
      urlDev: '',

      // Returned from GET /hint-impact/{id_link}
      hints: {},
      allArticles: {},
      hashes: {},
    }),
    computed: {
      id_site() {
        return this.$store.state.site.id_site
      },
      id_link() {
        return this.$store.state.id_link
      },
      articles() {
        return this.$store.state.article.latestArticles
      },
    },
    mounted() {
      this.urlDev = (window.location.host.includes('ohm.dev') ? '.dev' : '') + '.opoint.com'
    },
    methods: {
      getStyle(impact) {
        const s = {}

        if (impact) {
          s['background-color'] = '#242424'

          if (Math.abs(impact.real) > 0) {
            // Shade color according to impact
            let color = new Values(impact.real >= 0 ? '#13370b' : '#370b0b')

            color = color.tint(Math.abs(impact.real) / 500)

            if (color.getBrightness() > 70) {
              s['color'] = '#000000'
            }

            s['background-color'] = color.hexString()
          }
        }

        return s
      },
      getArticleHintImpact(id_site) {
        return new Promise((resolve, reject) => {
          OHMRepository.getArticleHintImpact(id_site)
          .then((response) => {
            if (response && response.data && response.data.hints) {
              this.hints = response.data.hints
              this.hashes = response.data.hashes
              this.allArticles = response.data.articles
              resolve()
            } else {
              Events.$emit('addNotification', {
                type: 'error',
                msg: (response && response.data && response.data.message) ? response.data.message : 'Could not load hint impact',
                timeout: 5
              })
              reject()
            }
          }).catch((error) => {
            Events.$emit('addNotification', {
              type: 'error',
              msg: (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Could not load hint impact',
              timeout: 5
            })
            reject()
          })
        })
      },
      updateQuery(id_site, id_link) {
        const q = {}
        if (id_site) {
          this.$store.commit('setIdSite', id_site)
          q['id_site'] = id_site
        }
        if (id_link) {
          this.$store.commit('setIdLink', id_link)
          q['id_link'] = id_link
        }
        this.$router.push({ query: q })

        this.loading = true
        this.getArticleHintImpact(id_site)
        .finally(() => {
          this.loading = false
        })
      }
    },
    watch: {
      '$route.query': {
        deep: true,
        immediate: true,
        handler(val) {
          if (!val.id_site && !val.id_link) {
            this.$router.push({ name: 'home' })
            return
          }
          this.updateQuery(val.id_site, val.id_link)
        }
      },
      id_site(val) {
        if (val) {
          this.updateQuery(val, this.id_link)
        }
      },
      id_link(val) {
        if (val) {
          this.updateQuery(this.id_site, val)
        }
      },
    }
  }
</script>

<style lang="sass">
  .hint-impact-table
    th
      text-align: center

    .artilce-name
      white-space: nowrap
</style>
